import $ from "jquery";
import Cookies from "js-cookie";
import React, { Component, Fragment } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import './commonheader.css';
import {
  getAllNavigation,
  getHeaderNavigation,
  getSetting,
  getTopNavigation,
  setLayout,
  setPath,
  setPathLayout,
  setSearchKey,
} from "../../../actions/Utils";
import Logo from "../../../img/logo.png";
import LangData from "../LangData";
import LangSelector from "./LangSelector";
import MultiMenus from "./Multimenu";
import MultiMenusMobile from "./MultimenuMobile";
import { isTokenExpired, clearAuthSession } from "../../../utils/utils";
import {
  addLoginUser,
  setIsLogin,
  setUserPermissionData,
} from "../../../actions/Users";
import toast from "react-hot-toast";

//import '../../../Styles/App.css'
//import '../../../Styles/Header.css'

class Commonheader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: "",
      header: {},
      top_menu: [],
      header_menu: [],
      megamenu_class: style.display_none,
      search: "",
      accept_cookies: false,
      setting: {},
      menu_open: false,
      showLogoutMenu: false,
      micrositeLoading: false,
    };
    this.megaMenuShow = this.megaMenuShow.bind(this);
    this.megaMenuHide = this.megaMenuHide.bind(this);
  }

  componentDidMount = () => {
    // Check if preClicked is set to 'pay_lic_bill' in localStorage
    // const preClicked = localStorage.getItem('preClicked');
    // if (preClicked === 'pay_lic_bill') {
    //   this.generateToken();
    // }
    this.props.getSetting().then((res) => {
      this.setState({
        setting: res,
      });
    });
    this.props
      .getHeaderNavigation({ navigation_name: "header" })
      .then((res) => {
        this.setState({
          header_menu: res,
        });

        // this.menuLoad();
      });
    var accept_cookiess = Cookies.get("accept_cookies");
    if (accept_cookiess && accept_cookiess == true) {
      this.setState({ accept_cookies: true });
    }

    // var login_token = Cookies.get('login_token');
    // if (!login_token || login_token !== localStorage.getItem('token')) {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("member_id");
    //     localStorage.removeItem("member_pass");
    // }
  };


  componentDidUpdate() {
    const rawToken = localStorage.getItem("authToken");
    const token = !isTokenExpired(rawToken) ? rawToken : null;
    const preClicked = localStorage.getItem("preClicked");

    if (preClicked === "pay_lic_bill" && token && !this.state.showLicModal) {
      this.generateToken();
    }
  }

  handleMenu = (status) => {
    this.setState({
      menu_open: status,
    });
  };

  menuLoad_header = () => {
    const thiss = this;
    setTimeout(() => {
      $(".menu > ul > li:has( > ul)").addClass("menu-dropdown-icon");
      $(".menu > ul > li > ul:not(:has(ul))").addClass("normal-sub");
      $(".menu > ul > li").hover(function (e) {
        if ($(window).width() > 943) {
          $(this).children("ul").stop(true, false).fadeToggle(150);
          e.preventDefault();
        }
      });

      $(".menu > ul > li").click(function () {
        if ($(window).width() <= 943) {
          $(this).children("ul").fadeToggle(150);
          if (!$(this).children("ul").length) {
            $(".menu > ul").toggleClass("show-on-mobile");
            $(".menu-mobile").toggleClass("menu-mobile-close");
          }
        }
      });

      $(".menu-mobile").click(function (e) {
        $(".menu > ul").toggleClass("show-on-mobile");
        $(this).toggleClass("menu-mobile-close");

        e.preventDefault();
      });
    }, 1000);

    const lang = Cookies.get("lang") ? Cookies.get("lang") : "bn";
    if (lang == "bn") {
      if (!$("body").hasClass("content_bangla")) {
        $("body").addClass("content_bangla");
      }
    } else {
      if ($("body").hasClass("content_bangla")) {
        $("body").removeClass("content_bangla");
      }
    }
  };

  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { history, match } = this.props;

    const { search } = this.state;
    if (search.length) {
      this.setState({ search: "" });
      history.push(`${process.env.PUBLIC_URL}${match.url}search/${search}`);
      $("div.mk-fullscreen-search-overlay").removeClass(
        "mk-fullscreen-search-overlay-show"
      );
    }
  };
  acceptCookies = (e) => {
    e.preventDefault();
    Cookies.set("accept_cookies", 1);
    this.setState({ accept_cookies: true });
  };
  static getDerivedStateFromProps(props, state) {
    return {
      header: props.headers,
      lang: props.lang,
    };
  }

  megaMenuShow = () => {
    this.setState({
      megamenu_class: style.display_block,
    });
  };
  megaMenuHide = () => {
    this.setState({
      megamenu_class: style.display_none,
    });
  };

  // handleLogout = () => {
  // localStorage.removeItem("token");
  //   localStorage.removeItem("authToken");
  //   localStorage.removeItem("member_id");
  //   localStorage.removeItem("member_pass");
  //   this.props.history.push(`${process.env.PUBLIC_URL}/`);
  // };
  handleLogout = () => {
    // Remove authentication data from localStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("activeItem");
    localStorage.removeItem("member_id");
    localStorage.removeItem("member_pass");

    // Dispatch Redux actions to reset authentication state
    this.props.setIsLogin(false);
    this.props.setUserPermissionData([]);
    this.props.addLoginUser({});

    // Redirect to home page
    this.props.history.push("/");

    //  // Optional: Force reload to ensure clean state
    //  window.location.reload();
  };

  generateToken = async () => {
    if (this.state.micrositeLoading) return;
    this.setState({ micrositeLoading: true });

    const rawToken = localStorage.getItem("authToken");
    const isExpired = isTokenExpired(rawToken);
    if (rawToken && isExpired) {
      clearAuthSession();
    }
    const token = isExpired ? null : rawToken;

    if (!token) {
      localStorage.setItem('preClicked', 'pay_lic_bill');
      toast.error("To Pay LIC Bill you have to login first");
      // If the user is not logged in, redirect to login page
      this.props.history.push("/login-office");
      this.setState({ micrositeLoading: false });
      return;
    }

    localStorage.removeItem('preClicked');

    const phone = this.props.loginuser?.mobile;

    if (!phone) {
      // alert("User phone number not found");
      this.setState({ micrositeLoading: false });
      return;
    }

    try {
      const res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/generateToken', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          bill_type: 'NEW-POLICY',
          order_id: 'ORD' + Date.now(),
          customer_phone: phone,
        }),
      });

      const data = await res.json();

      if (data.code === 200 && data.url) {
        this.setState({
          showLicModal: true,
          licUrl: data.url,
        });
      } else {
        alert('Failed to open LIC microsite');
      }
    } catch (e) {
      alert('Failed to open LIC microsite');
    } finally {
      this.setState({ micrositeLoading: false });
    }

    // Remove preClicked from localStorage after checking
    // localStorage.removeItem('preClicked');
  };

  render() {
    // const top_menu = this.props.headers.top_menu;
    const header_menu = this.props.headers.header_menu;
    //console.log("data setting state =", this.state);
    const { setting, menu_open } = this.state;
    // const lang = Cookies.get('lang')?Cookies.get('lang'):'bn';
    const lang = this.props.lang;
    var search_placeholder = lang == "bn" ? "অনুসন্ধান" : "look out";
    const rawToken = localStorage.getItem("authToken");
    const isExpired = isTokenExpired(rawToken);
    if (rawToken && isExpired) {
      clearAuthSession();
      if (this.props.loginuser && Object.keys(this.props.loginuser).length > 0) {
        this.props.addLoginUser({});
        this.props.setIsLogin(false);
      }
    }
    const token = isExpired ? null : rawToken;
    return (
      <Fragment>
        <header>
          {this.state.micrositeLoading && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.35)",
                zIndex: 9999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: 10,
                  padding: "18px 20px",
                  minWidth: 280,
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <div className="spinner-border text-primary" role="status" aria-label="Loading" />
                <div style={{ lineHeight: 1.2 }}>
                  <div style={{ fontWeight: 600 }}>Opening LIC Microsite…</div>
                  <div style={{ color: "#6c757d", fontSize: 13, marginTop: 4 }}>
                    Please wait.
                  </div>
                </div>
              </div>
            </div>
          )}
          <section className="topbar-section">
            <div className="container">
              <div className="topbar">
                <div className="topbar-info-left float-left">
                  <p>
                    <i className="fa fa-phone-alt"></i>
                    {lang === "en" && <Fragment>{setting.phone}</Fragment>}
                    {lang === "bn" && <Fragment>{setting.bn_phone}</Fragment>}
                  </p>
                  <p>
                    <i className="fa fa-envelope"></i> {setting.email}
                  </p>
                </div>

                <div className="topbar-info-right float-right d-flex align-items-center">
                  {token?.length > 0 ? (
                    <>
                      <p>
                        <Link to={{ pathname: "/dashboard_admin" }}>
                          Hi, {this.props.loginuser?.en_first_name || 'User'}
                        </Link>
                      </p>

                      <div className="dropdown">
                        <button
                          className="btn btn-outline-light border-0 mx-2"
                          type="button"
                          id="userDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {/* {localStorage.getItem("user_name") || "Unknown"}{" "}
                          <i className="fa fa-chevron-down"></i> */}
                          {/* <i className="fas fa-user"></i> */}
                          <i class="fas fa-user-tie"></i>
                        </button>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="userDropdown"
                          style={{ minWidth: "auto" }}
                        >
                          <button
                            className="dropdown-item"
                            onClick={this.handleLogout}
                          >
                            Logout
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p>
                      <Link to={{ pathname: "/login-office" }}>
                        <LangData keyname="login" />
                      </Link>
                    </p>
                  )}

                  <LangSelector />
                </div>
              </div>
            </div>
          </section>

          <section>
            <div className="container">
              <div className="d-flex top-middle">
                <div className="logo mr-auto mt-2">
                  <Link to={{ pathname: `/` }}>
                    <img src={Logo} alt="Logo" width="100" />
                  </Link>
                </div>
                <div className="payment-calculator d-flex justify-content-end">
                  {/* <div className="payment">
                                        
                                        <Link to={{pathname:`/paydirect-step-1`}} >
                                            <LangData keyname="payment" />  <img src={require('../../../img/icon/payment.svg').default} />
                                        </Link>

                                    </div> */}
                  {/* <div
                    className="calculator d-none d-lg-block"
                    onClick={this.state.micrositeLoading ? undefined : this.generateToken}
                    style={{
                      pointerEvents: this.state.micrositeLoading ? "none" : "auto",
                      opacity: this.state.micrositeLoading ? 0.6 : 1,
                    }}
                  >
                    <p>
                      <a
                        href="#"
                        rel="noopener noreferrer"
                        style={{ cursor: this.state.micrositeLoading ? "not-allowed" : "pointer" }}
                      >
                        {lang === "en" && <Fragment>Pay LIC Bill</Fragment>}
                        {lang === "bn" && (
                          <Fragment>এলআইসি বিল পরিশোধ করুন</Fragment>
                        )}
                      </a>
                    </p>
                  </div> */}
                  <div className="calculator d-none d-lg-block">
                    <p>
                      <a
                        href="https://easy.com.bd/insurance/premium-payment"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ cursor: "pointer" }}
                      >
                        {/* <i className="fa fa-chevron-double-right"></i> */}
                        {lang === "en" && <Fragment>Pay premium</Fragment>}
                        {lang === "bn" && (
                          <Fragment>প্রিমিয়াম পরিশোধ করুন</Fragment>
                        )}
                      </a>
                    </p>
                  </div>
                  {/* <div className="calculator d-none d-lg-block">
                    <Link to={{ pathname: `/return-calculator` }}>
                      <LangData keyname="rcalculator" />{" "}
                      <img
                        src={
                          require("../../../img/icon/calculator.svg").default
                        }
                      />
                    </Link>
                  </div> */}
                  <div className="calculator d-none d-lg-block">
                    <Link to={{ pathname: `/premium-calculator` }}>
                      <LangData keyname="calculator" />{" "}
                      <img
                        src={
                          require("../../../img/icon/calculator.svg").default
                        }
                      />
                    </Link>
                  </div>
                </div>
                <div className="search-box d-none d-lg-block">
                  <form action="#">
                    <input
                      type="text"
                      name="search"
                      value={this.state.search}
                      onChange={this.handleChange}
                      placeholder={search_placeholder}
                    />
                    <button
                      className="search-btn"
                      onClick={this.handleSubmit}
                      type="submit"
                    ></button>
                  </form>
                </div>
              </div>
            </div>
          </section>
          <section className="sticky-menu">
            <div className="container">
              <div className="main-menu">
                <div className="menu-container">
                  <MobileView>
                    {menu_open && (
                      <a
                        href="javscript:void(0)"
                        className="menu-mobile-close"
                        onClick={() => this.handleMenu(false)}
                      >
                        &nbsp;
                      </a>
                    )}
                    {!menu_open && (
                      <a
                        href="javscript:void(0)"
                        className="menu-mobile"
                        onClick={() => this.handleMenu(true)}
                      >
                        &nbsp;
                      </a>
                    )}
                  </MobileView>

                  <MobileView>
                    <div className="menu">
                      {/* <div className="mobile-logo custom-margin-left"> */}
                      <div className={`mobile-logo ${this.props.location.pathname === "/dashboard_admin" ? "custom-margin-left" : ""}`}>
                        <Link to={{ pathname: "/" }}>
                          <img src={Logo} alt="Logo" />
                        </Link>
                      </div>
                      <MultiMenusMobile
                        menus={header_menu}
                        lang={lang}
                        menu_open={menu_open}
                        handleMenu={(status) => this.handleMenu(status)}
                      />
                    </div>
                  </MobileView>
                  <BrowserView>
                    <div className="menu">
                      <MultiMenus menus={header_menu} lang={lang} />
                    </div>
                  </BrowserView>
                </div>
              </div>
            </div>
          </section>
          {/* This is the Modal of the LIC Microsite starts here */}
          {this.state.showLicModal && (
            <div className="modal fade show d-block" tabIndex="-1">
              <div className="modal-dialog modal-xl">
                <div className="modal-content">

                  <div className="modal-header">
                    <h5 className="modal-title">Pay LIC Bill</h5>
                    <button
                      type="button"
                      className="close"
                      onClick={() => this.setState({ showLicModal: false })}
                    >
                      &times;
                    </button>
                  </div>

                  <div className="modal-body p-0" style={{ height: '80vh' }}>
                    <iframe
                      src={this.state.licUrl}
                      title="LIC Microsite"
                      style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                      }}
                      allow="payment"
                    />
                  </div>

                </div>
              </div>
            </div>
          )}
          {/* This is the Modal of the LIC Microsite ends here  */}
        </header>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  headers: state.header,
  setting: state.utils.setting,
  lang: state.utils.lang,
  loginuser: state.user?.loginuser,
});

const mapDispatchToProps = (dispatch) => ({
  setPath: (requestData) => {
    dispatch(setPath(requestData));
  },
  setLayout: (requestData) => {
    dispatch(setLayout(requestData));
  },
  setPathLayout: (requestData) => {
    dispatch(setPathLayout(requestData));
  },
  setSearchKey: (requestData) => {
    dispatch(setSearchKey(requestData));
  },
  getAllNavigation: (requestData) => dispatch(getAllNavigation(requestData)),
  getTopNavigation: (requestData) => dispatch(getTopNavigation(requestData)),
  getHeaderNavigation: (requestData) =>
    dispatch(getHeaderNavigation(requestData)),
  getSetting: (requestData) => dispatch(getSetting(requestData)),
  setIsLogin: (status) => dispatch(setIsLogin(status)),
  setUserPermissionData: (data) => dispatch(setUserPermissionData(data)),
  addLoginUser: (user) => dispatch(addLoginUser(user)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Commonheader)
);

const style = {
  display_none: {
    display: "none",
  },
  display_block: {
    display: "block",
  },
};
